export default __webpack_public_path__ + "static/media/box-content.ed610c83.svg";